package ai.flowstorm.studio.ui.space

import ai.flowstorm.common.setProperty
import ai.flowstorm.common.ui.EntityTable
import ai.flowstorm.studio.model.Device
import ai.flowstorm.studio.model.User
import ai.flowstorm.studio.resources.space.DeviceResource
import io.kvision.i18n.I18n.tr
import io.kvision.modal.ModalSize
import io.kvision.tabulator.ColumnDefinition
import io.kvision.tabulator.Layout
import io.kvision.tabulator.TabulatorOptions
import io.kvision.utils.obj

class DeviceTable : EntityTable<Device>(
    caption = "Client Device",
    model = DeviceResource,
    tabulatorOptions = TabulatorOptions(
        layout = Layout.FITCOLUMNS,
        columns = listOf(
            ColumnDefinition(tr("Device ID"), Device::deviceId.name),
            ColumnDefinition(tr("Description"), Device::description.name),
            ColumnDefinition(tr("Location"), Device::location.name),
            ColumnDefinition(tr("Username"), FIELD_USER_USERNAME),
            ColumnDefinition(tr("Last Talk"), Device::lastTalk.name)
        )
    ),
    dataExtractor = {
        obj {
            setProperty(this, it::deviceId)
            setProperty(this, it::description)
            setProperty(this, it::location)
            setProperty(this, it::lastTalk)
            this[FIELD_USER_USERNAME] = it._user?.username
        }
    },
    entityComponentFactory = { DeviceForm(DeviceResource) },
    deleteEnabled = false,
    modalSize = ModalSize.LARGE,
    className = "content-panel"
) {
    companion object {
        const val FIELD_USER_USERNAME = "user_username"
    }
}
